import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { Link } from "gatsby";

function ServicePage() {
  return (
    <Layout>
      <SEO title="Services" />

      <section className="w-full px-4 sm:max-w-6xl mx-auto py-16 min-h-screen">
        <h1 className="text-3xl leading-tight font-extrabold text-gray-900 sm:text-4xl text-center">Services</h1>
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          If you have a project that requires something more custom, or has advanced requirements, feel free to reach out
          to <Link className="text-indigo-600 font-medium" to="/contact">me</Link> to discuss.
        </p>
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
           Some enhancements I can offer out of the box are:
        </p>         
        <ul className="mt-6 text-gray-800 sm:text-lg md:text-xl list-disc px-4">
          <li className="py-2">
            <span className="text-gray-900 font-semibold">Forms Integration</span> - 
              Forms such as a contact form hooked up to your email or email capture form integrated with your favorite subscriber management tool 
              like Mailchimp/Convertkit.
          </li>
          <li className="py-2">
            <span className="text-gray-900 font-semibold">Fully fleshed out websites</span> - 
            If you want something a bit more robust than Create React App or just a landing page.
          </li>          
          <li className="py-2">
            <span className="text-gray-900 font-semibold">Firebase integration</span> - 
            Firebase is an amazing service that does everthing from authentication to storage to functions.
            You can build a production ready Jamstack site with all the backend functionality delegated to Firebase.
          </li>
          <li className="py-2">
            <span className="text-gray-900 font-semibold">Restricted Pages</span> - 
            We can set your website up so you control which users can see which pages 
            e.g. make certain pages available only to premium members.            
          </li>          
          <li className="py-2">
            <span className="text-gray-900 font-semibold">Stripe integration</span> - 
            Your friendly neighborhood payment service. Stripe has a great suite of APIs that work with almost any use case.            
          </li>
          <li className="py-2">
            <span className="text-gray-900 font-semibold">Subscription Management</span> - 
            The Stripe Customer Portal offers a great way for users to self manage their subscription status (upgrade/downgrade/cancel).
            This makes your life much easier as you don't need to handle any of those events!
          </li>          
          <li className="py-2">
            <span className="text-gray-900 font-semibold">Headless Shopify eCommerce solutions</span> - 
            You can build out beautiful niche stores using your Shopify plan by leveraging their storefront API.
            See my <a className="text-indigo-600 font-semibold" target="_blank" rel="noreferrer" href="https://corgistickers.netlify.app/">CorgiStickers</a> 
            {' '} store for an idea. I built it on top of my regular store and continue to experiment. :)
          </li>
        </ul>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Of course this is not an exhaustive list and we can dive deeper into your particular use case.
          <br/><br/>Looking forward to hearing from you. :)
        </p>                                    
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Bilal
        </p>          
      </section>
    </Layout>
  );
}

export default ServicePage;